import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit"
import { RootState, AppThunk } from "@/app/store"
import { ClientDetailResponse } from "./api"
// import { Favour } from "./api_types"
// import { RedeemResponseRes } from "./api"

export type Lang = "zh" | "en" | "cn"
export type mode = "sign_in" | "register"

export interface AppState {
  loading: boolean
  lang: Lang
  code: string
  email: string
  returnUrl: string
  retryInSeconds: number
  clientDetail: ClientDetailResponse
  mode: mode
  backUrl: string
  countryCode: string
  phone: string
  otpTarget: string,
  password: string,
}

const initialState: AppState = {
  loading: true,
  lang: "zh",
  code: "",
  email: "",
  returnUrl: "",
  retryInSeconds: 0,
  clientDetail: {
    name: "",
    nameZh: "",
    loginMethods: [],
    countryCodes: [],
    omitPassword: false,
    passwordPatternRequirement: {
      minLength: 0,
      upperCase: false,
      lowerCase: false,
      number: false,
      specialCharacter: false,
    },
  },
  mode: "sign_in",
  backUrl: "",
  countryCode: "",
  phone: "",
  otpTarget: "",
  password: "",
}

// The function below is called a thunk and allows us to perform async logic. It
// can be dispatched like a regular action: `dispatch(incrementAsync(10))`. This
// will call the thunk with the `dispatch` function as the first argument. Async
// code can then be executed and other actions can be dispatched. Thunks are
// typically used to make async requests.
// export const incrementAsync = createAsyncThunk(
//   "counter/fetchCount",
//   async (amount: number) => {
//     const response = await fetchCount(amount)
//     // The value we return becomes the `fulfilled` action payload
//     return response.data
//   },
// )

export const appSlice = createSlice({
  name: "app",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    changeLang: (state, action: PayloadAction<Lang>) => {
      state.lang = action.payload
    },
    changeLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload
    },
    changeCode: (state, action: PayloadAction<string>) => {
      state.code = action.payload
    },
    changeEmail: (state, action: PayloadAction<string>) => {
      state.email = action.payload
    },
    changeReturnUrl: (state, action: PayloadAction<string>) => {
      state.returnUrl = action.payload
    },
    changeRetryInSeconds: (state, action: PayloadAction<number>) => {
      state.retryInSeconds = action.payload
    },
    changeClientDetail: (
      state,
      action: PayloadAction<ClientDetailResponse>,
    ) => {
      state.clientDetail = action.payload
    },
    changeMode: (state, action: PayloadAction<mode>) => {
      state.mode = action.payload
    },
    changeBackUrl: (state, action: PayloadAction<string>) => {
      state.backUrl = action.payload
    },
    changeCountryCode: (state, action: PayloadAction<string>) => {
      state.countryCode = action.payload
    },
    changePhone: (state, action: PayloadAction<string>) => {
      state.phone = action.payload
    },
    changeOtpTarget: (state, action: PayloadAction<string>) => {
      state.otpTarget = action.payload
    },
    changePassword: (state, action: PayloadAction<string>) => {
      state.password = action.payload
    },
    // changeFavour: (state, action: PayloadAction<Favour>) => {
    //   state.favour = action.payload
    // },
    // changeCodeExpiry: (state, action: PayloadAction<number>) => {
    //   state.codeExpiry = action.payload
    // },
    // changeRedemptionResponse: (state, action: PayloadAction<RedeemResponseRes|null>) => {
    //   state.redemptionResponse = action.payload
    // },
    // changeRedemptionId: (state, action: PayloadAction<string>) => {
    //   state.redemptionId = action.payload
    // },
    // increment: (state) => {
    // Redux Toolkit allows us to write "mutating" logic in reducers. It
    // doesn't actually mutate the state because it uses the Immer library,
    // which detects changes to a "draft state" and produces a brand new
    // immutable state based off those changes
    //   state.value += 1
    // },
    // decrement: (state) => {
    //   state.value -= 1
    // },
    // Use the PayloadAction type to declare the contents of `action.payload`
    // incrementByAmount: (state, action: PayloadAction<number>) => {
    //   state.value += action.payload
    // },
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  // extraReducers: (builder) => {
  //   builder
  //     .addCase(incrementAsync.pending, (state) => {
  //       state.status = "loading"
  //     })
  //     .addCase(incrementAsync.fulfilled, (state, action) => {
  //       state.status = "idle"
  //       state.value += action.payload
  //     })
  //     .addCase(incrementAsync.rejected, (state) => {
  //       state.status = "failed"
  //     })
  // },
})

export const {
  changeLang,
  changeLoading,
  changeCode,
  changeEmail,
  changeReturnUrl,
  changeRetryInSeconds,
  changeClientDetail,
  changeMode,
  changeBackUrl,
  changeCountryCode,
  changePhone,
  changeOtpTarget,
  changePassword,
  // changeFavour,
  // changeCodeExpiry,
  // changeRedemptionResponse,
  // changeRedemptionId
} = appSlice.actions

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
// export const selectCount = (state: RootState) => state.counter.value

// We can also write thunks by hand, which may contain both sync and async logic.
// Here's an example of conditionally dispatching actions based on current state.
// export const incrementIfOdd =
//   (amount: number): AppThunk =>
//   (dispatch, getState) => {
//     const currentValue = selectCount(getState())
//     if (currentValue % 2 === 1) {
//       dispatch(incrementByAmount(amount))
//     }
//   }

export default appSlice.reducer
